import { Action, Dispatch, bindActionCreators } from 'redux';
import { Provider, StateProps, DispatchProps } from '../components/provider/Provider';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { setVisitCode } from '../redux/ui/actions';
import { toast } from '../redux/message/actions';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState): StateProps {
  return {
    visitCode: state.ui.visitCode,
    markets: state.markets.markets,
    services: state.serviceOffering.services,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators({ onPageDidMount, onPageWillUnmount, setVisitCode, toast }, dispatch),
  };
}

export const ProviderContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Provider));
